import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

const runtimeProductionRaw = (window as any).__env?.PRODUCTION;
const hasRuntimeProduction = runtimeProductionRaw !== undefined && runtimeProductionRaw !== null;
const runtimeProduction = String(runtimeProductionRaw).toLowerCase() === 'true';
const isProduction = hasRuntimeProduction ? runtimeProduction : environment.production;

if (isProduction) {
  enableProdMode();
} else {
  document.body.classList.add('env-nonprod');
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
